import { z } from "zod";
import { SrpRequestParamsSchema } from "../../types";

export const MonthSchema = z.enum([
	"Jan",
	"Feb",
	"Mar",
	"Apr",
	"May",
	"Jun",
	"Jul",
	"Aug",
	"Sep",
	"Oct",
	"Nov",
	"Dec",
]);
export const YearSchema = z.coerce.number().min(1900).max(2100);
export const PricesDateMetadataMonthlySchema = z.record(
	YearSchema,
	MonthSchema.array(),
);
export type PricesDateMetadataMonthly = z.infer<
	typeof PricesDateMetadataMonthlySchema
>;

export const PricesDateMetadataDailySchema = z.record(
	YearSchema,
	z.record(MonthSchema, z.number().min(1).max(31)),
);
export type PricesDateMetadataDaily = z.infer<
	typeof PricesDateMetadataDailySchema
>;

export const ParamsSchema = SrpRequestParamsSchema.pick({
	type_id: true,
	shareclass_id: true,
})
	.required()
	.and(
		SrpRequestParamsSchema.pick({
			granularity: true,
		}),
	);
export type Params = z.infer<typeof ParamsSchema>;
